import Layout, { Breadcrumb } from 'components/layout'
import { Container, Tab, Button } from 'components/ui'
import { useUserSession } from 'hooks/use-user-session'
import { AddressHandler } from 'modules/address/containers'
import { UserChangePassword, UserOrderList } from 'modules/users/containers'
import UserChangeData from 'modules/users/containers/user-change-data'
import { FC } from 'react'
import { ROUTE_USER_SIGN_IN } from 'routes/user'
import s from './user-account.module.css'
import UserSubscription from '../../../modules/users/containers/user-subscription/user-subscription'
import { useAfiliado } from 'hooks/use-afiliado'
import tabStyles from 'components/ui/tab/tab.module.css'
import Link from 'next/link'
import AffiliateChangeData from 'modules/affiliates/containers/affiliate-change-data'

interface UserAccountProps {}

const { Tabs, Item, Content } = Tab

const UserAccount: FC<UserAccountProps> = () => {
  const { isLoggedIn, user } = useUserSession()
  const { isAfiliado, afiliadoSlug } = useAfiliado()
  const crumbs = [
    {
      label: 'Minha conta',
    },
  ]

  return (
    <Layout>
      <Breadcrumb crumbs={crumbs} />
      {isLoggedIn ? (
        <Container className={s.root}>
          <Tab>
            <div className={s.tabs}>
              <div className={s.sidebar}>
                <Tabs current={1} vertical>
                  <Item index={1}>Meus pedidos</Item>
                  <Item index={2}>Meus endereços</Item>
                  <Item index={3}>Alterar senha</Item>
                  <Item index={4}>Atualizar meus dados</Item>
                  <Item index={5}>Minhas Assinaturas</Item>
                  {isAfiliado && (
                    <Link href={`/afiliado/${afiliadoSlug || ''}`} passHref >
                      <a className={tabStyles.tab} style={{ display: 'block' }}>
                        Minha página de vendas afiliado
                      </a>
                    </Link>
                  )}
                  {isAfiliado && <Item index={7}>Meus dados afiliado</Item>}
                </Tabs>
              </div>
              <div className={s.content}>
                <Content index={1}>
                  <UserOrderList />
                </Content>
                <Content index={2}>
                  <AddressHandler recipient={user.name} id="null" onSelectAddress={() => {}} />
                </Content>
                <Content index={3}>
                  <UserChangePassword hasPasswordChanged={() => {}} />
                </Content>
                <Content index={4}>
                  <UserChangeData />
                </Content>
                <Content index={5}>
                  <UserSubscription />
                </Content>
                {isAfiliado && (
                  <Content index={7}>
                    <AffiliateChangeData />
                  </Content>
                )}
              </div>
            </div>
          </Tab>
        </Container>
      ) : (
        <Container className={s.root}>
          <p>
            Clique{' '}
            <Button href={ROUTE_USER_SIGN_IN} variant="text">
              aqui
            </Button>{' '}
            para iniciar sua sessão.
          </p>
        </Container>
      )}
    </Layout>
  )
}

export default UserAccount
